import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeServiceTypeCommand extends BaseCommand {
  CommandName = "ChangeServiceType";
  Command: { TmpId: string; Value: number; Calculate: boolean };
  constructor(sessionId: string, operationId: string, tmpId: string, value: number, calculate: boolean) {
    super(sessionId, operationId);
    this.Command = { TmpId: tmpId, Value: value, Calculate: calculate };
  }
}
